<template>
  <div class="variations-demo">
    <v-container fluid>
      <v-row>
        <v-col cols="12">
          <v-card>
            <v-card-title class="text-h4">
              <v-icon left class="mr-2">mdi-format-list-bulleted</v-icon>
              {{ $t("product_variations_demo") }}
            </v-card-title>
            <v-card-text>
              <p class="text-body-1 mb-4">
                {{ $t("variations_demo_description") }}
              </p>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <!-- Sample Product with Variations -->
      <v-row class="mt-4">
        <v-col cols="12" md="6">
          <v-card>
            <v-card-title>{{ $t("sample_product") }}</v-card-title>
            <v-card-text>
              <div class="product-info">
                <h3>T-Shirt Premium</h3>
                <p class="text-caption">
                  A high-quality t-shirt with multiple variations
                </p>

                <div class="product-stats">
                  <v-chip color="primary" small class="mr-2">
                    {{ $t("stock") }}: 185
                  </v-chip>
                  <v-chip color="success" small>
                    {{ $t("has_variations") }}: {{ $t("yes") }}
                  </v-chip>
                </div>
              </div>
            </v-card-text>
          </v-card>
        </v-col>

        <v-col cols="12" md="6">
          <v-card>
            <v-card-title>{{ $t("variation_summary") }}</v-card-title>
            <v-card-text>
              <div class="variation-summary">
                <div class="summary-item">
                  <v-icon color="primary">mdi-tag</v-icon>
                  <span class="ml-2"
                    >{{ $t("size") }}: 3 {{ $t("options") }}</span
                  >
                </div>
                <div class="summary-item">
                  <v-icon color="primary">mdi-tag</v-icon>
                  <span class="ml-2"
                    >{{ $t("color") }}: 3 {{ $t("options") }}</span
                  >
                </div>
                <div class="summary-item">
                  <v-icon color="success">mdi-currency-usd</v-icon>
                  <span class="ml-2"
                    >{{ $t("price_range") }}: 25,000 - 35,000 LAK</span
                  >
                </div>
              </div>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <!-- Interactive Variations Display -->
      <v-row class="mt-4">
        <v-col cols="12">
          <v-card>
            <v-card-title>{{ $t("interactive_demo") }}</v-card-title>
            <v-card-text>
              <ProductVariationDisplay
                :product="sampleProduct"
                :selected-options="selectedOptions"
                @option-selected="handleOptionSelected"
              />
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <!-- Selected Options Summary -->
      <v-row v-if="hasSelectedOptions" class="mt-4">
        <v-col cols="12">
          <v-card color="primary" dark>
            <v-card-title>{{ $t("selected_options_summary") }}</v-card-title>
            <v-card-text>
              <div class="selected-summary">
                <div
                  v-for="(option, variationId) in selectedOptions"
                  :key="variationId"
                  class="selected-item"
                >
                  <strong>{{ getVariationName(variationId) }}:</strong>
                  {{ option.la_name }}
                  <span class="ml-2"
                    >({{ option.price_sale | NumberFormat }})</span
                  >
                </div>
                <v-divider class="my-2"></v-divider>
                <div class="total-price">
                  <strong
                    >{{ $t("total_price") }}:
                    {{ calculateTotalPrice() | NumberFormat }}</strong
                  >
                </div>
              </div>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <!-- Feature List -->
      <v-row class="mt-4">
        <v-col cols="12">
          <v-card>
            <v-card-title>{{ $t("features") }}</v-card-title>
            <v-card-text>
              <v-list>
                <v-list-item v-for="feature in features" :key="feature.title">
                  <v-list-item-icon>
                    <v-icon color="success">{{ feature.icon }}</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>{{
                      $t(feature.title)
                    }}</v-list-item-title>
                    <v-list-item-subtitle>{{
                      $t(feature.description)
                    }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import ProductVariationDisplay from "@/components/products/ProductVariationDisplay.vue";
import { myMixin } from "@/mixin/main";
export default {
  name: "VariationsDemo",
  components: {
    ProductVariationDisplay,
  },
  mixins: [myMixin],
  data() {
    return {
      selectedOptions: {},
      sampleProduct: {
        id: 1,
        name: "T-Shirt Premium",
        has_variations: true,
        variations: [
          {
            id: 1,
            la_name: "ຂະໜາດ",
            en_name: "Size",
            variation_options: [
              {
                id: 1,
                la_name: "S",
                en_name: "Small",
                price_buy: 15000,
                price_sale: 25000,
                stock: 50,
              },
              {
                id: 2,
                la_name: "M",
                en_name: "Medium",
                price_buy: 18000,
                price_sale: 30000,
                stock: 75,
              },
              {
                id: 3,
                la_name: "L",
                en_name: "Large",
                price_buy: 20000,
                price_sale: 35000,
                stock: 60,
              },
            ],
          },
          {
            id: 2,
            la_name: "ສີ",
            en_name: "Color",
            variation_options: [
              {
                id: 4,
                la_name: "ສີດຳ",
                en_name: "Black",
                price_buy: 16000,
                price_sale: 28000,
                stock: 40,
              },
              {
                id: 5,
                la_name: "ສີຂາວ",
                en_name: "White",
                price_buy: 16000,
                price_sale: 28000,
                stock: 45,
              },
              {
                id: 6,
                la_name: "ສີເທົາ",
                en_name: "Gray",
                price_buy: 17000,
                price_sale: 29000,
                stock: 35,
              },
            ],
          },
        ],
      },
      features: [
        {
          icon: "mdi-format-list-bulleted",
          title: "multiple_variations",
          description: "multiple_variations_desc",
        },
        {
          icon: "mdi-currency-usd",
          title: "individual_pricing",
          description: "individual_pricing_desc",
        },
        {
          icon: "mdi-package-variant",
          title: "individual_stock",
          description: "individual_stock_desc",
        },
        {
          icon: "mdi-translate",
          title: "multilingual_support",
          description: "multilingual_support_desc",
        },
        {
          icon: "mdi-image",
          title: "option_images",
          description: "option_images_desc",
        },
      ],
    };
  },
  computed: {
    hasSelectedOptions() {
      return Object.keys(this.selectedOptions).length > 0;
    },
  },
  methods: {
    handleOptionSelected(data) {
      this.selectedOptions = data.allSelectedOptions;
    },
    getVariationName(variationId) {
      const variation = this.sampleProduct.variations.find(
        (v) => v.id === variationId
      );
      return variation ? variation.la_name : "";
    },
    calculateTotalPrice() {
      let total = 0;
      Object.values(this.selectedOptions).forEach((option) => {
        total += option.price_sale;
      });
      return total;
    },
  },
};
</script>

<style scoped>
.variations-demo {
  padding: 20px 0;
}

.product-info h3 {
  margin-bottom: 8px;
  color: var(--v-primary-base);
}

.product-stats {
  margin-top: 16px;
}

.variation-summary .summary-item {
  display: flex;
  align-items: center;
  margin-bottom: 8px;
}

.selected-summary .selected-item {
  margin-bottom: 8px;
}

.total-price {
  font-size: 1.1em;
  margin-top: 8px;
}
</style>
